// @ts-nocheck
import { init as initApm } from '@elastic/apm-rum';
import packageJson from '../../package.json';
import { getVaultBaseUrl } from './apiHostOverride';

const isLocalHost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

const getBackendOrigin = () => {
  const baseUrl = getVaultBaseUrl();
  if (!baseUrl) return null;
  return baseUrl.startsWith('http') ? baseUrl : `https://${baseUrl}`;
};

const getDistributedTracingOrigins = () => {
  const origins = [window.location.origin, getBackendOrigin()];

  /**
   * Remove null / undefined values.
   * Remove duplicate origins.
   */
  return [...new Set(origins.filter(Boolean))];
};

/**
 * Initialises the Elastic APM browser agent, attaches it to `window.apm`,
 * and restores the user context from localStorage (if available).
 *
 * Safe to call multiple times — subsequent calls after initialisation are
 * no-ops because `window.apm` will already be set.
 *
 * @returns {Object|null} The APM instance, or null if initialisation failed.
 */
const initApmService = () => {
  const isApmActive = import.meta.env.MODE === 'production';

  let apm = null;

  try {
    apm = initApm({
      serviceName: isLocalHost
        ? `${packageJson.name}-local`
        : `${packageJson.name}-${window.CONFIG?.ENV}`,

      serverUrl: window.CONFIG?.ERROR_LOGGER,
      serviceVersion: packageJson.version,
      environment: isLocalHost ? 'local' : window.CONFIG?.ENV,
      active: isApmActive,
      breakdownMetrics: true,
      transactionSampleRate: 1,
      distributedTracingOrigins: getDistributedTracingOrigins(),
      logLevel: isLocalHost ? 'debug' : 'warn',
      instrument: true,
      reportTransactionsWithoutSpans: true,
    });

    window.apm = apm;
  } catch (_error) {
    window.apm = null;
  }

  // Restore user context from localStorage
  try {
    const userDataStr = localStorage.getItem('user_data');

    if (userDataStr && apm) {
      const userData = JSON.parse(userDataStr);

      apm.setUserContext({
        id: userData?.id,
        username: userData?.username,
        email: userData?.email,
      });
    }
  } catch {
    // Do nothing
  }

  return window.apm;
};

export default initApmService;
